import React, { useEffect } from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import { User, LogOut, UserCircle } from 'lucide-react';
import { useAuth } from '../../AuthContext';
import { useParams, Link } from 'react-router-dom';

const UserDropdown = () => {
    const { tenantDomain } = useParams();
    const { user, updateTenantDomain } = useAuth();
    const userObj = typeof user === 'string' ? JSON.parse(user) : user;
    
    useEffect(() => {
        updateTenantDomain(tenantDomain);
    }, [tenantDomain, updateTenantDomain]);

    const handleLogout = async () => {
        try {
          const response = await fetch(`${process.env.REACT_APP_API_URL}/logout/`, {
            method: 'POST',
            credentials: 'include', // Includes cookies in the request
            headers: {
              'Content-Type': 'application/json',
              credentials: 'include'
            }
          });
    
          if (response.ok) {
            // Redirect to login page or refresh the app state
            window.location.href = tenantDomain ? `/${tenantDomain}/login` : '/install';
          } else {
            // Handle error cases
            console.error('Logout failed:', response.statusText);
          }
        } catch (error) {
          console.error('Logout error:', error);
        }
      };
  return (
    <Dropdown align="end">
      <Dropdown.Toggle 
        as={Button} 
        variant="link" 
        className="text-white p-1"
        id="user-dropdown"
      >
        <User size={20} />
      </Dropdown.Toggle>

      <Dropdown.Menu className="shadow-sm">
        {userObj && userObj.userId && (
          <Dropdown.Item as={Link} to={`/${tenantDomain}/user/${userObj.userId}`} className="d-flex align-items-center gap-2">
            <UserCircle size={18} />
            Profile
          </Dropdown.Item>
        )}
        <Dropdown.Divider />
        <Dropdown.Item 
          onClick={handleLogout}
          className="d-flex align-items-center gap-2 text-danger"
        >
          <LogOut size={18} />
          Logout
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default UserDropdown;
